
define('text!templates/components/recurring_product_compact/recurring_products.html',[],function () { return '<div class="list-container">\n\n</div>\n';});

